import { render, staticRenderFns } from "./OzCloseButton.vue?vue&type=template&id=2af7158e&"
import script from "./OzCloseButton.vue?vue&type=script&lang=ts&"
export * from "./OzCloseButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports